//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      empty: {
        email: '',
        password: ''
      },
      form: {},
      pageReady: false,
      processing: false,
      showPassword: false
    }
  },

  created() {
    this.setForm()
    this.form.email = this.$route.query.email || ''
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      setTimeout(() => {
        this.pageReady = true
      }, 1000)
    },

    setForm() {
      this.form = cloneDeep(this.empty)
    },

    toggleShowPassword() {
      this.showPassword = !this.showPassword
    },

    async send() {
      try {
        // Set processing
        this.processing = true

        // Login
        await this.$api.auth.login(this.form)

        // Redirect
        this.$router.push({
          path: '/area-restrita/secoes'
        })
      } catch (err) {
        // Log the error
        console.log(err)

        // Set processing
        this.processing = false

        // Show error
        this.$store.dispatch('modal/show', {
          type: 'danger',
          title: 'Erro na autenticação',
          message:
            'Houve algum erro ao tentar entrar no sistema, por favor verifique se os campos e-mail ou senha foram preenchidos corretamente ou se o usuário já foi aprovado.'
        })
      }
    }
  }
}
